export default "__VITE_ASSET__D1cUGEt0__"